// Keyboard backend for InputManager. Maps arrow/AD to steer, Space to jump
// (press/release tracked), Shift to tuck, E to item, J/K/L to tricks.
export class KeyboardInput {
  constructor(manager) {
    this.manager = manager;
    this.keys = new Set();
    this.enabled = false;
    this._boundDown = (e) => this._onDown(e);
    this._boundUp = (e) => this._onUp(e);
  }

  enable() {
    if (this.enabled) return;
    this.enabled = true;
    window.addEventListener('keydown', this._boundDown);
    window.addEventListener('keyup', this._boundUp);
  }

  disable() {
    if (!this.enabled) return;
    this.enabled = false;
    window.removeEventListener('keydown', this._boundDown);
    window.removeEventListener('keyup', this._boundUp);
  }

  _onDown(e) {
    const k = e.key.toLowerCase();
    if (e.repeat) return;
    this.keys.add(k);
    this._refresh();

    switch (k) {
      case ' ':
      case 'spacebar':
        e.preventDefault();
        this.manager.jumpDown();
        break;
      case 'e':
        this.manager.pressItem();
        break;
      case 'v':
        this.manager.toggleViewMode();
        break;
      case 'j':
        this.manager.pressTrick('A');
        break;
      case 'k':
        this.manager.pressTrick('B');
        break;
      case 'l':
        this.manager.pressTrick('C');
        break;
    }
  }

  _onUp(e) {
    const k = e.key.toLowerCase();
    this.keys.delete(k);
    this._refresh();

    if (k === ' ' || k === 'spacebar') {
      this.manager.jumpUp();
    }
  }

  _refresh() {
    let steer = 0;
    if (this.keys.has('arrowleft') || this.keys.has('a')) steer -= 1;
    if (this.keys.has('arrowright') || this.keys.has('d')) steer += 1;
    this.manager.setSteer(steer);
    this.manager.setTucking(this.keys.has('shift'));
  }
}
